import styled from 'styled-components';
export const ReadOnly: any = styled.div`
  opacity: ${({ readOnly }: any) => (readOnly ? 0.4 : 1)};
  pointer-events: ${({ readOnly }: any) => (readOnly ? 'none' : 'unset')};
`;
